import { render, staticRenderFns } from "./queuenumber.vue?vue&type=template&id=437999db&scoped=true&"
import script from "./queuenumber.vue?vue&type=script&lang=js&"
export * from "./queuenumber.vue?vue&type=script&lang=js&"
import style0 from "./queuenumber.vue?vue&type=style&index=0&id=437999db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437999db",
  null
  
)

export default component.exports